import './styles.scss'

import React from 'react'
import { useValues } from 'kea'

import I18n from 'lib/i18n'

import courseLogic from '~/scenes/course/show/logic'

export default function MobileBreadcrumb () {
  const {
    course: {
      breadcrumbs: { root, categories, city }
    }
  } = useValues(courseLogic)

  return (
    <div className='widget nospace'>
      <h3 className='boxtitle line'>{I18n.t('courses.index.breadcrumbs_bottom_section_title')}</h3>
      <div className='padding-no-top2'>
        <strong>
          <a href={root.url} rel='home'>
            <em className='rootTitle'>{root.title}</em>
          </a>
        </strong>
        <div className='breadcrumb-bottom-child'>
          <div className='main'>
            {categories &&
              categories.map((category, index) => {
                const isLastCategory = categories.length === index + 1

                return (
                  <div className='with-comma' key={category.id}>
                    <a
                      href={category.url}
                      style={{ marginRight: isLastCategory ? 0 : categories.length > 1 ? 12 : 0 }}
                      className='categoryUrl'
                    >
                      <em className='categoryTitle'>{category.title}</em>
                      <span>{isLastCategory ? '' : categories.length > 1 ? ',' : ''}</span>
                    </a>
                  </div>
                )
              })}
            {city.title}
          </div>
        </div>
      </div>
    </div>
  )
}
